import React, { useState, useEffect } from "react"; // Import useEffect
import { RiDashboardLine } from "react-icons/ri";
import { LuUserSquare2 } from "react-icons/lu";
import { TbUsers } from "react-icons/tb";
import { MdOutlineLocalOffer, MdPayment } from "react-icons/md";
import { RiUserSettingsLine } from "react-icons/ri";
import { TbHandFinger } from "react-icons/tb";
import { LiaSignOutAltSolid } from "react-icons/lia";
import { NavLink } from "react-router-dom";
import { BiSolidCoupon } from "react-icons/bi";
import { FiCast, FiPhone } from "react-icons/fi";
import { IoIosHelpCircleOutline } from "react-icons/io";
import { VscFeedback } from "react-icons/vsc";
import background from "../assests/images/Doodle Iamge.png";
import logo from "../assests/images/Texpidea Logo 1.png";
import nameapp from "../assests/images/texpidea-1@2x.png";
import Header from "./Header";
import { useNavigate } from "react-router-dom";

const Sidebar = ({ children }) => {
  const navigate = useNavigate();
  
  // MODIFICATION 1: Initialize state from localStorage, defaulting to 'true' (open).
  const [isOpen, setIsOpen] = useState(() => {
    const savedState = localStorage.getItem("sidebarIsOpen");
    // If there's a saved state, use it. Otherwise, default to open.
    return savedState !== null ? JSON.parse(savedState) : true;
  });

  // MODIFICATION 2: Save state to localStorage whenever it changes.
  useEffect(() => {
    localStorage.setItem("sidebarIsOpen", JSON.stringify(isOpen));
  }, [isOpen]);

  const pathname = window.location.pathname;
  const toggle = () => setIsOpen(!isOpen);

  // These variables are constant, so they don't need to be in the component body
  const dashboaedcompoWidth = "100%";
  const headersidebar = "100%";
  const mainwidth = "100%";

  const sidebarWidth = {
    lg: { open: "w-[310px]", closed: "w-[100px]" },
    xl: { open: "w-[310px]", closed: "w-[104px]" },
    "2xl": { open: "w-[310px]", closed: "w-[104px]" },
  };

  const circleWidth = {
    lg: { open: "w-[200px] h-[75px]", closed: "w-[80px] h-[80px]" },
    xl: { open: "w-[220px] h-[75px]", closed: "w-[90px] h-[90px]" },
    "2xl": { open: "w-[200px] h-[75px]", closed: "w-[70px] h-[70px]" },
  };

  const menuItem = [
    {
      path: "/dashboard",
      name: "Dashboard",
      icon: <RiDashboardLine className={`${pathname === "/dashboard" ? "text-[#FF9900]" : "text-white"}`} />,
    },
    {
      path: "/admins",
      name: "Admins",
      icon: <LuUserSquare2 className={`${pathname === "/admins" ? "text-[#FF9900]" : "text-white"}`} />,
    },
    {
      path: "/users",
      name: "Users",
      icon: <TbUsers className={`${pathname === "/users" || pathname === "/appcreate" ? "text-[#FF9900]" : "text-white"}`} />,
    },
    {
      path: "/affiliate",
      name: "Affiliate",
      icon: <MdOutlineLocalOffer className={`${pathname === "/affiliate" ? "text-[#FF9900]" : "text-white"}`} />,
    },
    {
      path: "/modelsManager",
      name: "Models Manager",
      icon: <RiUserSettingsLine className={`${pathname === "/modelsManager" || pathname === "/unitymodels" ? "text-[#FF9900]" : "text-white"}`} />,
    },
    {
      path: "/projectManager",
      name: "Project Manager",
      icon: <TbHandFinger className={`${pathname === "/projectManager" ? "text-[#FF9900]" : "text-white"}`} />,
    },
    {
      path: "/subscription",
      name: "Subscription",
      icon: <BiSolidCoupon className={`${pathname === "/subscription" || pathname === "/subscriotionCuppon501" ? "text-[#FF9900]" : "text-white"}`} />,
    },
    {
      path: "/ads",
      name: "App Ads",
      icon: <FiCast className={`${pathname === "/ads" ? "text-[#FF9900]" : "text-white"}`} />,
    },
    {
      path: "/apphelp",
      name: "App Help",
      icon: <IoIosHelpCircleOutline className={`${pathname === "/apphelp" ? "text-[#FF9900]" : "text-white"}`} />,
    },
    {
      path: "/appfeedback",
      name: "App Feedback",
      icon: <VscFeedback className={`${pathname === "/appfeedback" ? "text-[#FF9900]" : "text-white"}`} />,
    },
    {
      path: "/contactus",
      name: "Contact Us",
      icon: <FiPhone className={`${pathname === "/contactus" ? "text-[#FF9900]" : "text-white"}`} />,
    },
    {
      path: "/payuser",
      name: "Pay User",
      icon: <MdPayment className={`${pathname === "/payuser" ? "text-[#FF9900]" : "text-white"}`} />,
    },
  ];

  const handleLogout = () => {
    localStorage.removeItem("token");
    navigate("/");
    window.location.reload();
  };

  return (
    <div className="h-screen container-2xl">
      <div
        className="relative h-screen bg-center bg-cover shadow-md"
        style={{
          backgroundImage: "radial-gradient(77.96% 148.88% at 50% -45.8%, #f90 0%, #00003f 100%)",
          boxShadow: "0px 4px 4px 0px rgba(0, 0, 0, 0.25)",
          position: "relative",
        }}
      >
        <img src={background} alt="background" className="w-full h-screen" />

        <div className="absolute top-0 flex w-full h-full">
          <div className="sidebarpage">
            <div
              className={`sidebar text-white transition-all duration-500 h-full flex flex-col ${
                isOpen ? sidebarWidth.lg.open : sidebarWidth.lg.closed
              } lg:${isOpen ? sidebarWidth.xl.open : sidebarWidth.xl.closed} 2xl:${
                isOpen ? sidebarWidth["2xl"].open : sidebarWidth["2xl"].closed
              }`}
            >
              {/* Logo Section */}
              <div className="flex items-center justify-center px-4 top_section lg:py-7 xl:py-7 2xl:py-[90px] flex-shrink-0">
                <div className="flex items-center justify-center">
                  <div
                    className="rounded-full flex justify-center items-center border border-white border-opacity-69 bg-white bg-opacity-45 backdrop-blur-[13.1px] cursor-pointer"
                    style={{
                      width: isOpen ? circleWidth.lg.open : circleWidth.lg.closed,
                      height: isOpen ? circleWidth.lg.open.split(" ")[1] : circleWidth.lg.closed.split(" ")[1],
                    }}
                    onClick={toggle}
                  >
                    <div className="">
                      <img src={logo} alt="logo" className="w-13 lg:w-16 xl:w-20 2xl:w-28" />
                    </div>
                    <div style={{ display: isOpen ? "block" : "none" }} className="pb-6 pr-4 lg:pb-3 xl:pb-5">
                      <img src={nameapp} alt="logo" className="w-19 lg:w-[120px] xl:w-32" />
                    </div>
                  </div>
                </div>
              </div>

              {/* Navigation Section */}
              <div className="flex flex-col flex-grow px-2 justify-between overflow-hidden">
                <div
                  className="flex flex-col overflow-y-auto pr-2 menu-container" // Added menu-container class
                  style={{
                    scrollbarWidth: "thin",
                    scrollbarColor: "rgba(255, 255, 255, 0.5) transparent",
                  }}
                >
                  <style jsx>{`
                    .menu-container::-webkit-scrollbar {
                      width: 6px;
                    }
                    .menu-container::-webkit-scrollbar-track {
                      background: rgba(255, 255, 255, 0.1);
                      border-radius: 3px;
                    }
                    .menu-container::-webkit-scrollbar-thumb {
                      background: rgba(255, 255, 255, 0.3);
                      border-radius: 3px;
                    }
                    .menu-container::-webkit-scrollbar-thumb:hover {
                      background: rgba(255, 255, 255, 0.5);
                    }
                  `}</style>
                  <div> {/* Removed unnecessary className */}
                    {menuItem.map((item, index) => (
                      <NavLink
                        to={item.path}
                        key={index}
                        className="sidebaricon flex space-x-5 lg:space-x-3 xl:space-x-5 2xl:space-x-5 items-center transition-all duration-500 border-t border-white hover:bg-white hover:bg-opacity-10"
                        activeClassName="" // This is not needed for v6, NavLink automatically adds 'active' class
                      >
                        <div className="flex justify-center items-center py-2 pl-6 lg:py-2 lg:text-[20px] xl:pl-6 lg:pl-5 xl:text-3xl xl:py-[13px] text-3xl 2xl:text-5xl 2xl:pl-4 2xl:py-7">
                          {item.icon}
                        </div>
                        <div
                          style={{ display: isOpen ? "block" : "none" }}
                          className="text-2xl lg:text-[15px] xl:text-[16px] 2xl:text-3xl"
                        >
                          {item.name}
                        </div>
                      </NavLink>
                    ))}
                  </div>
                </div>

                {/* Sign Out Section */}
                <div className="border-t border-white pt-4 pb-4 flex-shrink-0 bg-gradient-to-b from-transparent to-[rgba(0,0,63,0.8)] backdrop-blur-sm">
                  <div
                    className="cursor-pointer signout flex flex-col items-center text-white hover:bg-white hover:bg-opacity-10 py-2 rounded transition-all duration-300"
                    onClick={() => {
                      if (window.confirm("Are you sure you want to sign out?")) {
                        handleLogout();
                      }
                    }}
                  >
                    <LiaSignOutAltSolid
                      className="text-2xl font-bold 2xl:text-3xl mb-1"
                      style={{ transform: "rotate(270deg)" }}
                    />
                    <p className="text-[13px] fw-2 2xl:text-[20px]">Sign Out</p>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="flex flex-col h-screen" style={{ width: dashboaedcompoWidth }}>
            <div className="" style={{ width: headersidebar }}>
              <Header />
            </div>
            <main className="" style={{ width: mainwidth }}>
              <div className="h-[82vh] flex bg-gray-300">
                <div className="w-full">{children}</div>
              </div>
            </main>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Sidebar;